"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackBlur = void 0;
var interactions_1 = require("../interactions/interactions");
var get_events_url_1 = require("../utils/get_events_url");
var trackBlur = function (environmentName, applicationId, selector, value, label, otherArgs) {
    if (otherArgs === void 0) { otherArgs = {}; }
    var interaction = new interactions_1.Interaction({
        endpoint: "".concat((0, get_events_url_1.getEventsUrl)(environmentName), "/v2/pages/interaction"),
        applicationId: applicationId,
    });
    return interaction.track('blur', __assign({ category: 'interactions', target: selector, value: value, label: label }, otherArgs));
};
exports.trackBlur = trackBlur;
